import emit from '../../common/events';
import store from '../../store/store';
import { StoreState } from '../../store/store.interface';
import { getUserDataForUserAnalytics } from '../user-profile/user-profile.selectors';

export class SearchV3Analytics {
  static search({
    element,
    id,
    term,
    businessUnit,
    redirectUrl,
    storeCategory,
    searchPageType,
    activeTab,
  }: {
    element: Element;
    id: string;
    term: string;
    businessUnit: string;
    redirectUrl?: string;
    storeCategory: string | undefined;
    searchPageType: string;
    activeTab?: string;
  }): void {
    const state: StoreState = store.getState() as StoreState;

    emit({
      element,
      name: 'search',
      detail: {
        id,
        term,
        businessUnit: businessUnit || 'all',
        redirect: redirectUrl,
        isSearchRedirect: !!redirectUrl,
        url: window.location.href,
        store: storeCategory,
        user: getUserDataForUserAnalytics(state),
        searchPageType: searchPageType,
        area: 'header',
        subarea: 'globalnav',
        activeTab: activeTab || 'Product',
        catalog: activeTab ? activeTab.toUpperCase() : 'PRODUCTS',
      },
    });
  }

  static searchSuggestion({
    element,
    id,
    term,
    businessUnit,
    redirectUrl,
    searchPageType,
    activeTab,
  }: {
    element: any;
    id: string;
    term: string;
    businessUnit: string;
    redirectUrl?: string;
    searchPageType: string;
    activeTab?: string;
  }): void {
    emit({
      element,
      name: 'searched-for-term-suggestion',
      detail: {
        id,
        term,
        redirect: redirectUrl,
        isSearchRedirect: !!redirectUrl,
        searchPageType: searchPageType,
        url: window.location.href,
        area: 'header',
        subarea: 'globalnav',
        activeTab: activeTab || 'Product',
        catalog: businessUnit,
        eventName: 'searched-for-term-suggestion',
      },
    });
  }

  static businessUnit({
    element,
    id,
    label,
    term,
    businessUnit,
    searchPageType,
    activeTab,
  }: {
    element: any;
    id: string;
    label: string;
    term: string;
    businessUnit: string;
    searchPageType: string;
    activeTab?: string;
  }): void {
    emit({
      element,
      name: 'click',
      detail: {
        id,
        label,
        term,
        businessUnit: businessUnit || 'all',
        searchPageType: searchPageType,
        url: window.location.href,
        area: 'header',
        subarea: 'globalnav',
        activeTab: activeTab || 'Product',
      },
    });
  }

  static searchResults({
    element,
    id,
    term,
    store: storeCategory,
    totalResults,
    searchPageType,
    catalog,
    searchText,
    activeTab,
  }: {
    element: any;
    id: string;
    term: string;
    store: string | undefined;
    totalResults: number;
    searchPageType: string;
    catalog: string;
    searchText: any;
    activeTab: string;
  }): void {
    const state: StoreState = store.getState() as StoreState;

    emit({
      element,
      name: 'search-results',
      detail: {
        id,
        term,
        redirect: false,
        isSearchRedirect: false,
        store: storeCategory,
        url: window.location.href,
        user: getUserDataForUserAnalytics(state),
        totalResults,
        searchPageType,
        catalog,
        searchText,
        activeTab,
        area: 'header',
        subarea: 'globalnav',
      },
    });
  }

  static searchResultsV2({
    element,
    id,
    term,
    store: storeCategory,
    totalResults,
    searchPageType,
    fieldValueFilter,
  }: {
    element: any;
    id: string;
    term: string;
    store: string | undefined;
    totalResults: number;
    searchPageType: string;
    fieldValueFilter: any;
  }): void {
    const state: StoreState = store.getState() as StoreState;

    emit({
      element,
      name: 'search-results-v2',
      detail: {
        id,
        term,
        redirect: false,
        isSearchRedirect: false,
        store: storeCategory,
        url: window.location.href,
        user: getUserDataForUserAnalytics(state),
        totalResults,
        fieldValueFilter,
        catalog: 'SUPPORT',
        searchPageType,
        area: 'header',
        subarea: 'globalnav',
        searchText: {
          productDiscovery: 'search',
          searchAttempts: 1,
          searchTerms: [{
            searchTerm: term,
            totalSearchResults: totalResults,
          }],
          pageDetails: {
            pageNumber: 1,
            index: 1,
            currentPageLength: 10,
          },
        },
      },
    });
  }

  static searchTermRedirect({
    element,
    id,
    term,
    redirectUrl,
    searchPageType,
    searchText,
  }: {
    element: any;
    id: string;
    term: string;
    redirectUrl: string;
    searchPageType: string;
    searchText: any;
  }): void {
    const state: StoreState = store.getState() as StoreState;

    emit({
      element,
      name: 'search-term-redirect',
      detail: {
        id,
        term,
        redirect: true,
        isSearchRedirect: true,
        url: redirectUrl,
        user: getUserDataForUserAnalytics(state),
        totalResults: 0,
        searchPageType,
        searchText,
        area: 'header',
        subarea: 'globalnav',
      },
    });
  }
}
